import _ from 'lodash';
import { httpNoAuth } from '@/utils/axios';

const init = () => ({
  competitionId: undefined,
  season: undefined,
  preferredTab: undefined,
});

export default {
  namespaced: true,
  state: init(),
  mutations: {
    updateCompetitionId(state, payload) {
      state.competitionId = payload;
    },
    updateSeason(state, payload) {
      state.season = payload;
    },
    updatePreferredTab(state, payload) {
      state.preferredTab = payload;
    }
  },
  actions: {
    async updateCompetitionId({ commit }, {competitionId}) {
      if (competitionId) commit('updateCompetitionId', competitionId);
    },
    async updateSeason({ commit }, {season}) {
      console.log('updateSeason', season);
      if (season) commit('updateSeason', season);
    }
  },
  getters: {
    competitionId(state) {
      return state.competitionId;
    },
    season(state) {
      return state.season;
    },
    preferredTab(state) {
      return state.preferredTab;
    }
  },
};
